import React, { useState, useRef } from 'react';
import {
	ApButtonMain,
	ApButtonSecondary,
	ApButtonText,
	ApSimpleSearch,
	ApButtonGroup,
} from '@alixpartners/ui-components';
import {
	Wrapper,
	Footer,
	List,
	ActionsWrapper,
	SearchWrapper,
	NoDataWrapper,
	ContentWrapper,
} from './FilterOptions.styles';
import { VirtualList } from './VirtualList';
import isEqual from 'lodash/isEqual';

export const FilterOptions = ({
	options = [],
	selected: selectedProp,
	onChange,
	onCancel,
}) => {
	const [search, setSearch] = useState('');
	const listWrapperRef = useRef();
	const [selected, setSelected] = useState(selectedProp || []);
	const searchOptions = search
		? options.filter(({ label }) =>
				label.toLowerCase().includes(search.toLowerCase())
		  )
		: options;
	const availableOptions = searchOptions.filter(item => !item.disabled);

	const onSearchChange = query => {
		setSearch(query);
	};
	const onSearchClear = () => {
		setSearch('');
	};

	const handleChange = option => {
		let newSelected = [];

		if (selected.includes(option.value)) {
			newSelected = selected.filter(item => item !== option.value);
		} else {
			newSelected = [...selected, option.value];
		}

		setSelected(newSelected);
	};

	const selectAll = () => {
		if (availableOptions.length === 0) {
			return;
		}

		setSelected(
			Array.from(
				new Set([...selected, ...availableOptions.map(item => item.value)])
			)
		);
	};

	const clear = () => {
		const newSelected = search
			? selected.filter(
					item => !availableOptions.find(option => option.value === item)
			  )
			: [];

		setSelected(newSelected);
	};

	const handleApply = () => {
		onChange(selected);
	};

	const isApplyDisabled = isEqual(selected, selectedProp);

	return (
		<Wrapper>
			<ContentWrapper>
				<ActionsWrapper>
					<ApButtonGroup>
						<ApButtonText onClick={selectAll}>Select all</ApButtonText>
						<ApButtonText onClick={clear}>Clear</ApButtonText>
					</ApButtonGroup>
					<SearchWrapper>
						<ApSimpleSearch
							onChange={onSearchChange}
							onClear={onSearchClear}
							value={search}
						/>
					</SearchWrapper>
				</ActionsWrapper>
				{search && searchOptions.length === 0 ? (
					<NoDataWrapper>No results found</NoDataWrapper>
				) : (
					<List innerRef={listWrapperRef}>
						<VirtualList
							data={searchOptions}
							selected={selected}
							onChange={handleChange}
							wrapperRef={listWrapperRef}
						/>
					</List>
				)}
			</ContentWrapper>
			<Footer>
				<ApButtonSecondary onClick={onCancel}>Cancel</ApButtonSecondary>
				<ApButtonMain onClick={handleApply} disabled={isApplyDisabled}>
					Apply Filters
				</ApButtonMain>
			</Footer>
		</Wrapper>
	);
};

export default FilterOptions;
